import { useNavigate, useLocation, useParams } from 'react-router-dom';
import './TopNav.css';

const navItems = [
  { path: 'identity', label: 'Identity' },
  { path: 'teaching', label: 'Behavior' },
  { path: 'knowledge-files', label: 'Knowledge' },
  { path: 'environment', label: 'Filesystem' },
  { path: 'builder', label: 'Connections' },
  { path: 'escalation', label: 'Escalation' },
  { path: 'escalation-logs', label: 'Esc. Logs' },
  { path: 'knowledge', label: 'Knowledge Base' },
  { path: 'master-memory', label: 'Memory' },
  { path: 'logs', label: 'Logs' }
];

export default function TopNav({ agent, children }) {
  const { agentId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname.split('/').pop();

  return (
    <header className="topnav">
      <div className="topnav-left">
        <button className="topnav-back" onClick={() => navigate('/portal')} title="Back to dashboard">
          &larr;
        </button>
        <div className="topnav-agent">
          <span className="topnav-agent-initial">
            {agent?.name?.charAt(0).toUpperCase() || '?'}
          </span>
          <div className="topnav-agent-info">
            <span className="topnav-agent-name">{agent?.name || 'Unnamed'}</span>
            <span className="topnav-agent-sub">{agent?.industry || 'Not configured'}</span>
          </div>
        </div>
      </div>

      <nav className="topnav-links">
        {navItems.map(item => (
          <button
            key={item.path}
            className={`topnav-link ${currentPath === item.path ? 'active' : ''}`}
            onClick={() => navigate(`/portal/agent/${agentId}/${item.path}`)}
          >
            {item.label}
          </button>
        ))}
      </nav>

      <div className="topnav-right">{children}</div>
    </header>
  );
}
